<script>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import router from "@/router/index.js";

export default {
  setup() {
    // Variables
    const isLoading = ref(true);

    onMounted(async () => { });

    // I18n
    const { t, tm } = useI18n();

    return {
      t,
      tm,
      isLoading,
    }
  },
};
</script>

<template>
  <footer class="py-8">
    <div class="container md:max-w-full grid grid-cols-1 md:grid-cols-7 gap-4 px-4">
      <div class="pl-8">
        <ul class="space-y-2">
          <li><a href="https://wiseguide.getautowise.com/" target="_blank" class="hover:text-gray-400">{{ t('footer.knowledge_center', { app_name: t('app_name') }) }}</a></li>
        </ul>
      </div>
      <div class="pl-8">
        <ul class="space-y-2">
          <li><a href="https://wiseguide.getautowise.com/about/" target="_blank" class="hover:text-gray-400">{{ t('footer.about_blitzify', { app_name: t('app_name') }) }}</a></li>
        </ul>
      </div>
      <div class="pl-8">
        <ul class="space-y-2">
          <li><a href="https://wiseguide.getautowise.com/contact/" target="_blank" class="hover:text-gray-400">{{ t('footer.contact_us', { app_name: t('app_name') }) }}</a></li>
        </ul>
      </div>
      <div class="pl-8"></div>
      <div class="pl-8"></div>
      <div class="pl-8"></div>
      <a href="https://www.intelichek.com/">
        <div class="">
          <div class="float-right pr-16 whitespace-nowrap">
            <div v-for="blurb in tm('footer.powered_by_credit')">
              {{ blurb }}
            </div>
          </div>
          <img src="../assets/images/InteliChek Automotive - Transparent Background.png" alt="Logo 1" class="h-8 hidden lg:block mr-4 float-right pr-10">
        </div>
      </a>
      <!-- <div>
        <h3 class="font-semibold mb-4 uppercase">{{ t('footer.company') }}</h3>
        <ul class="space-y-2">
          <li><a href="#" class="hover:text-gray-400">{{ t('footer.about_blitzify', { app_name: t('app_name') }) }}</a></li>
          <li><a href="#" class="hover:text-gray-400">{{ t('footer.blitzify_blog', { app_name: t('app_name') }) }}</a></li>
          <li><a href="#" class="hover:text-gray-400">{{ t('footer.press_center') }}</a></li>
        </ul>
      </div>

      <div>
        <h3 class="font-semibold mb-4 uppercase">{{ t('footer.service') }}</h3>
        <ul class="space-y-2">
          <li><a href="#" class="hover:text-gray-400">{{ t('footer.quote_a_service') }}</a></li>
          <li><a href="#" class="hover:text-gray-400">{{ t('footer.find_your_quote') }}</a></li>
          <li><a href="#" class="hover:text-gray-400">{{ t('footer.providers_by_state') }}</a></li>
        </ul>
      </div>

      <div>
        <h3 class="font-semibold mb-4 uppercase">{{ t('footer.knowledge_center') }}</h3>
        <ul class="space-y-2">
          <li><a href="#" class="hover:text-gray-400">{{ t('footer.comments') }}</a></li>
          <li><a href="#" class="hover:text-gray-400">{{ t('footer.media_center') }}</a></li>
          <li><a href="#" class="hover:text-gray-400">{{ t('footer.documents') }}</a></li>
        </ul>
      </div>

      <div>
        <h3 class="font-semibold mb-4 uppercase">{{ t('footer.help_center') }}</h3>
        <ul class="space-y-2">
          <li><a href="#" class="hover:text-gray-400">{{ t('footer.contact_us') }}</a></li>
        </ul>
      </div>

      <div>
        <h3 class="font-semibold mb-4 uppercase">{{ t('footer.connect_with_us') }}</h3>
      </div> -->
    </div>
  </footer>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/components/footer';
</style>